import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "fullWidth", "color", "label", "bottomLabel", "error", "warning", "success", "maskProps", "inputRef", "focused", "labelProps", "fieldProps", "containerProps", "type", "onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, Grid } from '@mui/material';
import { TextMask } from '@elements/form/fields/text-mask';
import { StyledFormControl, StyledFormHelperErrorText, StyledFormHelperSuccessText, StyledFormHelperText, StyledFormHelperWarningText, StyledInputBase, StyleFormHelperWrapper } from './phone-field.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PhoneField = function PhoneField(_ref) {
  var name = _ref.name,
      fullWidth = _ref.fullWidth,
      color = _ref.color,
      label = _ref.label,
      bottomLabel = _ref.bottomLabel,
      error = _ref.error,
      warning = _ref.warning,
      success = _ref.success,
      maskProps = _ref.maskProps,
      inputRef = _ref.inputRef,
      focused = _ref.focused,
      labelProps = _ref.labelProps,
      fieldProps = _ref.fieldProps,
      containerProps = _ref.containerProps,
      type = _ref.type,
      _onChange = _ref.onChange,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var inputName = name && "".concat(name, "-textfield");
  var isError = !!error;
  var isWarning = !!warning;
  var isSuccess = !!success;
  var literalProps = {
    htmlFor: inputName,
    id: inputName,
    errorId: inputName && "".concat(inputName, "-error-text")
  };
  var TextFieldMaskProps = maskProps ? {
    inputComponent: TextMask,
    inputProps: maskProps
  } : {};
  return /*#__PURE__*/_jsx(StyledFormControl, {
    error: isError,
    fullWidth: fullWidth,
    focused: focused,
    children: /*#__PURE__*/_jsx(Grid, _objectSpread(_objectSpread({
      container: true,
      rowSpacing: 0.5,
      columnSpacing: 2,
      alignItems: "center"
    }, containerProps), {}, {
      children: /*#__PURE__*/_jsx(Grid, _objectSpread(_objectSpread({
        item: true,
        flex: "1 1"
      }, fieldProps), {}, {
        children: /*#__PURE__*/_jsxs(Box, {
          position: "relative",
          children: [/*#__PURE__*/_jsx(StyledInputBase, _objectSpread(_objectSpread(_objectSpread({
            error: isError,
            id: literalProps.id,
            "aria-describedby": inputName,
            name: name,
            fullWidth: fullWidth,
            color: color,
            label: label,
            variant: "outlined",
            defaultCountry: "ru",
            preferredCountries: ['ru'] // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ,
            onChange: function onChange(maskedValue) {
              return _onChange(maskedValue === null || maskedValue === void 0 ? void 0 : maskedValue.replace(/[\s\-\\(\\)]/g, ''));
            }
          }, TextFieldMaskProps), restProps), {}, {
            sx: {
              '& svg': {
                height: '14px'
              }
            }
          })), isError && /*#__PURE__*/_jsx(StyleFormHelperWrapper, {
            children: /*#__PURE__*/_jsx(StyledFormHelperErrorText, {
              id: literalProps.errorId,
              children: error
            })
          }), isWarning && /*#__PURE__*/_jsx(StyleFormHelperWrapper, {
            children: /*#__PURE__*/_jsx(StyledFormHelperWarningText, {
              id: literalProps.errorId,
              children: warning
            })
          }), isSuccess && /*#__PURE__*/_jsx(StyleFormHelperWrapper, {
            children: /*#__PURE__*/_jsx(StyledFormHelperSuccessText, {
              id: literalProps.errorId,
              children: success
            })
          }), bottomLabel && !isError && !isWarning && !isSuccess ? /*#__PURE__*/_jsx(StyleFormHelperWrapper, {
            children: /*#__PURE__*/_jsx(StyledFormHelperText, {
              children: bottomLabel
            })
          }) : null]
        })
      }))
    }))
  });
};

export { PhoneField };